import { BaseViewModel } from "@iot-platform/core";
import { injectable } from "inversify";
import { action, makeObservable, observable } from "mobx";

export const ActionMenuFooterKey = {
    list: "list",
    map: "map",
} as const;

type ActionMenuFooterKeyType = keyof typeof ActionMenuFooterKey;

@injectable()
export class StationLayoutMobileViewModel extends BaseViewModel {
    @observable
    menuFooterSelectedKey: ActionMenuFooterKeyType = ActionMenuFooterKey.list;

    constructor() {
        super();
        makeObservable(this);
    }

    @action
    setMenuFooterSelectedKey(key: ActionMenuFooterKeyType): void {
        this.menuFooterSelectedKey = key;
    }
}
